import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const textareaVariants = tv({
  variants: {
    size: {
      sm: "min-h-18",
      default: "min-h-21",
      lg: "min-h-24"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
export {
  textareaVariants
};
//# sourceMappingURL=index.js.map
